import React, { useEffect, useState } from "react";
import "../../assets/css/Checkout.css";
import MainBanner from "../../Components/Banner/MainBanner";
import Header from "../../Components/Header/Header";
import Footer from "../../Components/Footer/Footer";
import StripeForm from "../../Components/PaymentMethod/StripeForm";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  GetAllAddress,
  GetCouponCode,
  GetGiftCode,
  PostMakeDefaultAddress,
  PostPlaceOrder,
} from "../../network/Network";
import { AllAddress } from "../../redux/actions/AuthActions";
import { toast } from "react-toastify";
import { ClearCart } from "../../redux/actions/CartActions";
import AddressModal from "../../Components/Modal/AddressModal";

function Checkout() {
  const navigate = useNavigate();
  const [addnewAddress, setAddnewAddress] = useState(false);
  const dispatch = useDispatch();
  const ImageUrlRedux = useSelector((state) => state.AuthReducer.urlData);
  const Token = useSelector((state) => state.AuthReducer.token);
  const CartDataRedux = useSelector((state) => state.CartReducer.cartData);
  const AddressDataRedux = useSelector((state) => state.AuthReducer.address);
  const userData = useSelector((state) => state.AuthReducer.users);
  const [promoCode, setPromoCode] = useState("");
  const [subTotal, setSubTotal] = useState(0);
  const Location = useLocation();
  const CheckOutData = Location?.state?.data;
  const [postAddress, setPostAddress] = useState([]);
  const [saveAddressLoading, setSaveAddresLoading] = useState(false);
  const [giftCode, setGiftCode] = useState("");
  const [couponCode, setCouponCode] = useState("");
  const [giftData, setGiftData] = useState();
  const [couponData, setCouponData] = useState();
  const [couponLoading, setCouponLoading] = useState(false);
  const [giftLoading, setGiftLoading] = useState(false);
  const [isOpenAddressModal, setIsOpenAddressModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [totalDonation, setTotalDonation] = useState(0);

  const TotalAmount = () => {
    let i;
    let total = 0;
    let donationTotal = 0;
    for (i = 0; i < CheckOutData?.CartData.length; i++) {
      let i;
      let total = 0;
      let donationTotal = 0;
      for (i = 0; i < CheckOutData?.CartData.length; i++) {
        if (CheckOutData?.CartData[i]?.campaign_price) {
          donationTotal =
            parseInt(donationTotal) +
            parseInt(CheckOutData?.CartData[i]?.campaign_price);
        }
        if (
          CheckOutData?.CartData[i]?.type &&
          CheckOutData?.CartData[i]?.type == "bulk"
        ) {
          total = total + CheckOutData?.CartData[i]?.price * 1;
        } else {
          total =
            total +
            CheckOutData?.CartData[i]?.price *
              CheckOutData?.CartData[i]?.quantity;
        }
        if (CheckOutData?.CartData[i]?.campaign_price) {
          total =
            parseInt(total) +
            parseInt(CheckOutData?.CartData[i]?.campaign_price);
        }
        if (CheckOutData?.CartData[i]?.addon_item) {
          let j;
          for (j = 0; j < CheckOutData?.CartData[i]?.addon_item.length; j++) {
            total =
              parseInt(total) +
              parseInt(
                CheckOutData?.CartData[i]?.addon_item[j]?.addon_item[0]
                  ?.variation[0]?.price
              );
          }
        }
      }
      setSubTotal(total);
      setTotalDonation(donationTotal);
    }
  };

  useEffect(() => {
    TotalAmount();
  }, [CartDataRedux]);

  useEffect(() => {
    setSaveAddresLoading(true);
    GetAllAddress(Token)
      .then((res) => {
        setSaveAddresLoading(false);
        dispatch(AllAddress(res?.data));
      })
      .catch((err) => {
        setSaveAddresLoading(false);
      });
  }, [postAddress]);

  const MakeDefault_Handler = (e, id) => {
    e.preventDefault();
    let data = {
      address_id: id,
    };
    PostMakeDefaultAddress(data, Token)
      .then((res) => {
        toast.success(res?.data?.message);
        setPostAddress(res?.data);
        setSaveAddresLoading(false);
        setLoading(false);
      })
      .catch((err) => {
        setSaveAddresLoading(false);
        setLoading(false);
      });
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const styling = {
    marginTop: "10px",
    width: "100%",
    padding: "8px 16px",
    borderRadius: "20px",
  };

  const ApplyCouponCodeHandler = (e) => {
    e.preventDefault();
    setCouponLoading(true);
    let data = {
      code: couponCode,
      amount: subTotal,
    };
    GetCouponCode(data, Token)
      .then((res) => {
        setCouponLoading(false);
        setCouponData(res?.data?.data);
        toast.success("Successfully Apply");
        setCouponCode("");
        setLoading(false);
      })
      .catch((err) => {
        setCouponLoading(false);
        if (err?.response?.data?.errors[0]?.message) {
          toast.error(err?.response?.data?.errors[0]?.message);
          setLoading(false);
        }
        setLoading(false);
        toast.error(err?.response?.data?.errors);
      });
  };

  const ApplyGiftCodeHandler = (e) => {
    e.preventDefault();
    setGiftLoading(true);
    let data = {
      code: giftCode,
    };
    GetGiftCode(data, Token)
      .then((res) => {
        setGiftLoading(false);
        setGiftData(res?.data?.data);
        toast.success(res?.data?.message);
        setGiftCode("");
      })
      .catch((err) => {
        setGiftLoading(false);
        if (err?.response?.data?.errors[0]?.message) {
          toast.error(err?.response?.data?.errors[0]?.message);
        }
        toast.error(err?.response?.data?.message);
      });
  };

  const PlaceOrderHandler = (e, stripe_token) => {
    e.preventDefault();
    setSaveAddresLoading(false);
    setLoading(true);
    let data = {
      order_data: {
        coupon_discount: couponData?.discount ? couponData?.discount : 0,
        coupon_code: couponData?.coupon ? couponData?.coupon?.code : " ",
        gift_certificate_price: giftData?.amount ? giftData?.amount : 0,
        gift_certificate_code: giftData?.code ? giftData?.code : " ",
        total: subTotal,
        _token: stripe_token,
        products: CheckOutData?.CartData,
      },
    };

    if (!AddressDataRedux?.[0]) {
      toast.error("Add address first");
      setLoading(false);
    } else {
      PostPlaceOrder(data, Token)
        .then((res) => {
          setLoading(false);
          dispatch(ClearCart());
          toast.success("Order placed successfully!");
          setTimeout(() => {
            navigate(`/thankyou`);
          }, 600);
          setSaveAddresLoading(false);
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
          if (err?.response?.data?.errors[0]?.code == "stock") {
            toast?.error(err?.response?.data?.errors[0]?.message);
            setSaveAddresLoading(false);
            setLoading(false);
          }
          if (err?.response?.data?.errors) {
            setSaveAddresLoading(false);
            setLoading(false);
            toast?.error(err?.response?.data?.errors);
          }
        });
    }
  };

  const HandleShowAddress = () => {
    setAddnewAddress(!addnewAddress);
  };
  return (
    <>
      <Header />
      <MainBanner name={"Check Out"} />

      {/* <!-- checkout-section starts here --> */}
      <section className="checkout-page">
        <div className="container">
          <form action="thank-you.php">
            <div className="row">
              <div className="col-lg-6">
                <div className="first-top-bar">
                  <h3>Shipment Details</h3>
                </div>

                <div className="saved-address">
                  <div className="title">
                    <h5>Use Saved Addresses</h5>
                  </div>
                  {AddressDataRedux?.map((item, index) => {
                    return (
                      <label key={index + 12523} className="container">
                        <input
                          onClick={(e) => MakeDefault_Handler(e, item?.id)}
                          type="radio"
                          checked={item?.default === 1}
                          name="radio"
                        />
                        <span className="checkmark">
                          <div className="select-address">
                            <div className="selection">
                              <i className="fa fa-check" aria-hidden="true"></i>
                            </div>
                            <div className="radio-btn">
                              <span></span>
                            </div>
                            <div className="address-detail">
                              <h5>
                                <span className="property">Country:</span>
                                <span className="value">{item?.country}</span>
                                <span className="property pl-4">State:</span>
                                <span className="value">{item?.state}</span>
                              </h5>
                              <h5>
                                <span className="property">Address:</span>
                                <span className="value">
                                  {item?.address}, {item?.appartment}
                                </span>
                              </h5>
                              <h5>
                                <span className="property">Phone:</span>
                                <span className="value">+{item?.phone}</span>
                              </h5>
                              <div className="button-group">
                                <button
                                  className={`${
                                    item?.default === 0
                                      ? "btn-default-checkout"
                                      : // btn btn-light default
                                        "btn-no-default-checkout "
                                  }`}
                                  disabled={item?.default === 1 ? true : false}
                                  onClick={(e) =>
                                    MakeDefault_Handler(e, item?.id)
                                  }
                                >
                                  {saveAddressLoading
                                    ? "Loading..."
                                    : "Default"}
                                </button>
                              </div>
                            </div>
                          </div>
                        </span>
                      </label>
                    );
                  })}
                </div>
                <div className="add-new-address">
                  <div className="form-check py-3 margin-est">
                    <label
                      className="form-check-label label_ana"
                      onClick={(e) => setIsOpenAddressModal(true)}
                    >
                      Add New Address
                    </label>
                  </div>
                  <div className="payment-details">
                    <div className="heading">
                      <h3>Payment Details</h3>
                    </div>
                    <div className="saved-payment-method">
                      <StripeForm
                        styling={styling}
                        paynow="Confirm Order"
                        PaymentHandler={PlaceOrderHandler}
                        loading={loading}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-1"></div>
              <div className="col-lg-5">
                <div className="second-top-bar">
                  <div className="title pb-4">
                    <h3>Order Summary</h3>
                  </div>

                  <div className="form-group">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Promo Code"
                      value={couponCode}
                      onChange={(e) => setCouponCode(e.target.value)}
                    />
                    <button
                      onClick={(e) => ApplyCouponCodeHandler(e)}
                      disabled={couponLoading}
                      type="button"
                    >
                      {couponLoading ? "Loading" : "APPLY"}{" "}
                      <img src="img/right-arrow.svg" alt="" />
                    </button>
                  </div>
                </div>
                <div className="cart-product-detail">
                  <div className="title">
                    <h3>Products Details</h3>
                  </div>
                  <div className="checkout-products ">
                    {CheckOutData?.CartData?.map((item, index) => {
                      return (
                        <div className="products br-right" key={index}>
                          <div className="abt-product">
                            <div className="img-box">
                              <figure>
                                <img
                                  src={`${ImageUrlRedux?.product_thumbnail_url}/${item?.productitem?.thumbnail}`}
                                  alt="123"
                                />
                              </figure>
                            </div>
                            <div className="pro-dtl">
                              <h5 className="name">
                                {item?.productitem?.name}
                              </h5>
                              {item?.productitem?.leaf_type ? (
                                <ul className="variations">
                                  <li>
                                    Leaf Type: {item?.productitem?.leaf_type}
                                  </li>
                                </ul>
                              ) : null}

                              {item?.addon_item ? (
                                <ul className="variations">
                                  {item?.addon_item?.map((item) => {
                                    return (
                                      <li>
                                        AddOn: {item?.addon_item[0]?.name}
                                        <br />$
                                        {item?.addon_item[0]?.variation[0]
                                          ? item?.addon_item[0]?.variation[0]
                                              ?.price
                                          : null}
                                        <br />
                                        {item?.addon_item[0]?.variation[0]
                                          ? item?.addon_item[0]?.variation[0]
                                              ?.size
                                          : null}
                                      </li>
                                    );
                                  })}
                                </ul>
                              ) : null}

                              {item?.type == "bulk" ? (
                                <ul className="variations">
                                  <li>Type: {item?.type}</li>
                                </ul>
                              ) : null}
                            </div>
                          </div>
                          <div className="product-price">
                            <h4 className="price">{item?.quantity} x</h4>
                          </div>
                          <div className="product-price">
                            <h4 className="price">${item?.price}</h4>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                  <div className="pricing-details">
                    <div className="item-total">
                      <h4 className="property">Donation Amount :</h4>
                      <h4 className="value">
                        ${totalDonation ? totalDonation : 0}
                      </h4>
                    </div>
                    <div className="item-total">
                      <h4 className="property">Item Total :</h4>
                      <h4 className="value">${subTotal}</h4>
                    </div>
                    <div className="item-total">
                      <h4 className="property">Shipment & Delivery :</h4>
                      <h4 className="value">$0</h4>
                    </div>
                    <div className="item-total">
                      <h4 className="property">Promo Applied :</h4>
                      <h4 className="value">
                        -${couponData?.discount ? couponData?.discount : 0}
                      </h4>
                    </div>
                  </div>
                  <div className="order-total">
                    <h3 className="property">Order Total</h3>
                    <h3 className="value">
                      {" "}
                      $
                      {couponData || giftData
                        ? parseInt(subTotal) -
                          parseInt(
                            couponData?.discount
                              ? couponData?.discount
                              : 0 + giftData
                              ? giftData?.amount
                              : 0
                          )
                        : subTotal}
                    </h3>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </section>
      {/* <!-- checkout-section ends here --> */}

      <Footer />

      <AddressModal
        isOpenAddressModal={isOpenAddressModal}
        setIsOpenAddressModal={setIsOpenAddressModal}
        postAddress={postAddress}
        setPostAddress={setPostAddress}
      />
    </>
  );
}

export default Checkout;
